var map = {
	"./1.webp": 869,
	"./2.webp": 7816,
	"./3.webp": 5755,
	"./4.webp": 6630,
	"./5.webp": 6385,
	"./6.webp": 4788,
	"./7.webp": 8967,
	"./8.webp": 4690
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9453;